<template>
  <div class="recordNo">
    <img :src="imgurl" class="img_bg">
    <p class="system">光逸科技创新公共管理平台系统</p>
    <p class="systemDesc">光逸科技创新内部专用系统，致力于提高工作效率!</p>
    <!-- <p class="btn">
        <a target="" href="">前往大麦系统</a>
    </p> -->
    <p class="remark_number">
        <a target="_blank" href="http://beian.miit.gov.cn">粤ICP备19113656号</a>
    </p>
  </div>
</template>

<script>
export default {
  data(){
    return{
      imgurl: require('../assets/img/recordNo.svg')
    }
  }

}
</script>

<style>
  .recordNo{width: 100%;height: 100%;display: flex;align-items: center;justify-content: center;flex-direction: column;}
  .recordNo>.img_bg{width: 40.65%;}
  #think_page_trace_open{display: none;}
  .recordNo>.remark_number{position: absolute;bottom: 20px;width: 100%;text-align: center;}
  .recordNo>.remark_number>a{color: #3597FF;font-size: 14px;text-decoration: none;}
  .recordNo>.remark_number>a:hover{color: #72afd2;}
  .system{font-size: 24px;color: #030303;    margin-top: 2%;margin-bottom: 0;}
  .systemDesc{color: #808080;font-size: 14px;    margin: 10px 0 0;}
  .recordNo>.btn{margin: 6vh 0 5vh 0;}
  .recordNo>.btn >a{padding: 0 15px;display: inline-block;text-decoration: none;border-radius: 5px;
  background-color: #3597FF;height: 36px;line-height: 36px;color: #FFFFFF;font-size: 14px;}
</style>